import React, { useEffect, useState } from 'react'
import { Doughnut } from 'react-chartjs-2'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const options = {
  maintainAspectRatio: false,
  aspectRatio: 1,
  plugins: {
    clip: true,
    responsive: true,
    datalabels: {
      formatter: function (value, ctx) {
        return ctx.chart.data.labels[ctx.dataIndex] + '\n' + [value] + ' %'
      },
      textAlign: 'center',
      color: 'white',
      anchor: 'center',
      clamp: true,
      display: 'auto',
    },

    legend: {
      display: true,
      position: 'right',
      align: 'center',
      labels: { color: 'rgba(255,255,255,0.72)' },
    },
    title: {
      display: false,
      text: '',
    },
  },
}

export default function DonutChart({ doutdata }) {
  const [labels, setlabels] = useState([])
  const [datavalue1, setDatavalue1] = useState([])
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  useEffect(() => {
    let d1 = []
    let d2 = []
    let d3 = []
    if (doutdata) {
      doutdata.forEach((e) => {
        d1.push(e.classification)
        d2.push(parseInt(e.objectif))
        d3.push(parseFloat(e.reel < 0 ? e.reel * -1 : e.reel).toFixed(2))
      })
    }
    setlabels(d1)
    setDatavalue1(d2)
  }, [doutdata])
  const data = {
    labels,
    datasets: [
      {
        label: '',
        data: datavalue1,
        backgroundColor: ['#0d6efd', '#fd7e14', '#0dcaf0', '#6c757d', '#dc3545', '#fd7e14'],
        borderColor: ['#0d6efd', '#fd7e14', '#0dcaf0', '#6c757d', '#dc3545', '#fd7e14'],
        borderWidth: 1,
      },
    ],
  }
  return (
    <Box
      display={'flex'}
      height={250}
      width={'100%'}
      sx={{
        bgcolor: 'rgba(255,255,255,0.07)',
        border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: 2,
        p: 2,
      }}
    >
      <Box sx={{ width: '100%' }}>
        <Box sx={{ color: '#fff', fontWeight: 850, fontSize: 15 }}>{t('finance.monBudget.objectivesDistribution')}</Box>
        <Box sx={{ color: 'rgba(255,255,255,0.55)', fontSize: 12, mb: 1 }}>
          {t('finance.monBudget.objectivesDistributionSubtitle')}
        </Box>
      <Doughnut data={data} options={options} />
      </Box>
    </Box>
  )
}
